module.exports = __webpack_public_path__ + "static/img/scene02.85a5d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene02.png
// module id = 7Bfj
// module chunks = 1